export var MarmitonContentTypeName;

(function (MarmitonContentTypeName) {
  MarmitonContentTypeName["Ingredient"] = "MARMITON_ORG_INGREDIENT";
  MarmitonContentTypeName["Unit"] = "MARMITON_ORG_UNIT";
  MarmitonContentTypeName["Utensil"] = "MARMITON_ORG_UTENSIL";
})(MarmitonContentTypeName || (MarmitonContentTypeName = {}));